var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.iframeUrl !== null)?_c('iframe',{attrs:{"src":("" + _vm.iframeUrl),"id":"i-frame","width":"100%","height":"800","frameborder":"0","crossorigin":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }